import React, { useCallback, useState } from 'react';
import { Alert, Box } from '@indeed/ifl-components';
import AppVersionUtil from 'Utils/AppVersionUtil';
import JsvMetricsLogger from 'Utils/JsvMetricsLogger';
import { style } from './AppUpdateBanner.jss';
import AppUpdateMessage from './AppUpdateMessage';
// Keyed by the version we're nudging TOWARD, so raising the threshold surfaces the banner
// again rather than staying dismissed forever. Dismissal has to persist: /start and /home
// are separate routes, so a per-mount flag reappears the moment the user taps through.
const dismissedKey = (target) => `rirekisho_app_update_dismissed::${target}`;
const AppUpdateBanner = ({ recommendedVersion, minSupportedIosVersion }) => {
    const target = AppVersionUtil.isAppleDevice()
        ? recommendedVersion?.ios
        : recommendedVersion?.android;
    const [dismissed, setDismissed] = useState(() => !!target && localStorage.getItem(dismissedKey(target)) === '1');
    const handleDismiss = useCallback(() => {
        setDismissed(true);
        if (target) {
            localStorage.setItem(dismissedKey(target), '1');
        }
        JsvMetricsLogger.log('click', 'app_update_banner', 'app_update_dismiss');
    }, [target]);
    if (dismissed || !AppVersionUtil.shouldPromptUpdate(recommendedVersion)) {
        return null;
    }
    return (React.createElement(Alert, { status: "info", onDismiss: handleDismiss, sx: style.main },
        React.createElement(Box, { sx: style.content },
            React.createElement(AppUpdateMessage, { recommendedVersion: recommendedVersion, minSupportedIosVersion: minSupportedIosVersion }))));
};
export default AppUpdateBanner;
